import { Component } from '@angular/core';

import { SettingsService } from 'src/app/shared/services/settings.service';
import { PendingGroupInvitesPromptService } from 'src/app/shared/services/pending-group-invites-prompt.service';
import { AuthErrorModalService } from 'src/app/shared/services/auth-error-modal.service';
import { AppUpdateService } from 'src/app/shared/services/app-update.service';
import { MfaPromptService } from 'src/app/shared/services/mfa-prompt.service';

@Component({
    selector: 'app-private',
    templateUrl: './private.layout.html',
    styleUrls: ['./private.layout.scss'],
    standalone: false
})
export class PrivateLayoutComponent {
  constructor(
    private settingsService: SettingsService,
    private pendingGroupInvitesPromptService: PendingGroupInvitesPromptService,
    private authErrorModalService: AuthErrorModalService,
    private appUpdateService: AppUpdateService,
    private mfaPromptService: MfaPromptService,
  ) {
    this.settingsService.init();
    this.pendingGroupInvitesPromptService.init();
    this.authErrorModalService.init();
    this.appUpdateService.init();
    this.mfaPromptService.init();
  }
}
